/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

/**
 * ! These paths can change as the project evolves.
 * ! Some routes can be simplified since we are using redux and some parameters may not be needed
 */

export enum StartUpRoutePath {
  ROOT = '/',
  SIGNIN_SINGNUP = '/signinSignup',
  CODE = '/signinWithCode',
  SIGNIN = '/signin',
  GDPR = '/gdpr',
}

export enum PublicRoutePath {
  ABOUT = '/about',
  ABOUT_ELEMENT = '/:section/about/:id',
  PRIVACY = '/privacy',
  PRIVACY_NOTICE = '/privacy/notice',
  PRIVACY_CONSENT = '/privacy/consent',
  HELP = '/help',
  ERROR = '/error/:errorCode?',
}

export enum PrivateRoutePath {
  HELP = '/help',
  PROFILES_LIST = '/profiles/list',
  PROFILES_ADD = '/profiles/add',
  PROFILES_EDIT = '/profiles/edit/:id', // TODO: probably no necessary. for now we only use SETTINGS_PROFILES_EDIT
  SETTINGS = '/settings',
  SETTINGS_PARENTAL = '/settings/parental',
  SETTINGS_PIN = '/settings/pin',
  SETTINGS_ACCESSIBILITY = '/settings/accessibility',
  SETTINGS_PROFILES_ADD = '/settings/profiles/create',
  SETTINGS_PROFILES_EDIT = '/settings/profiles/edit/:id',
  MYTV = '/mytv',
  MYTV_WATCH_NEXT = '/mytv/watchNext',
  MYTV_RAIL = '/mytv/cat/:menuItemId',
  MYTV_RAIL_CATEGORY = '/mytv/cat/:menuItemId/:railId',
  WATCHTV = '/watchtv',
  ONDEMAND = '/ondemand',
  ONDEMAND_NEXT_LEVEL = '/ondemand/cat/:menuItemId',
  ONDEMAND_GRID = '/ondemand/cat/:menuItemId/all/:categoryItemId?',
  PROGRAM_INFO = '/:section/info/:assetType/:assetId',
  FOLDER_INFO = '/:section/info/folder/:assetId',
  FOLDER_INFO_GRID = '/:section/info/folder/all/:assetId/:channelId',
  SEARCH = '/search',
}

export enum MyTVRoutePath {
  WISHLIST = 'wishlist',
  PURCHASES = 'purchases',
  RECORDINGS = 'recordings',
  SCHEDULED_RECORDINGS = 'scheduled',
  WATCH_NEXT = 'watchNext',
}

export const PRIVATE_DEFAULT_ROUTE = PrivateRoutePath.WATCHTV;

export type RoutePath = StartUpRoutePath | PublicRoutePath | PrivateRoutePath;
